import React, { Component } from 'react'
import { graphql, compose } from 'react-apollo'
import { translate } from 'react-i18next'
import { withRouter } from 'react-router-dom'

import { Loader, Form, TextAreaInput } from '../../../UI'
import { validateRequired } from '../../../../libs/validation'

import UPDATE_LOCAL_TOUR from '../../../../graphql/ActivitySteps/UpdateLocalTourWhatYouBring.graphql'
import { NotificationManager } from 'react-notifications';

class NeedToBring extends Component {
  state = {
    saving: false
  }

  componentDidMount() {
    this.setState({
      whatYouBring: this.props.currentSteps.whatYouBring || ''
    })
  }

  handleSubmit = values => {
    const { data, updateLocalTour, updateSteps, history } = this.props

    this.setState({
      saving: true
    })

    updateLocalTour({
      variables: {
        id: this.props.currentSteps.id,
        whatYouBring: values.whatYouBring
      }
    }).then(() => {
      this.setState(
        {
          saving: false
        },
        () => {
          updateSteps()
          NotificationManager.success('Needs to bring updated', 'Success', 5000)
          if (data.allLocalTours && data.allLocalTours[0]) {
            history.push(`/activity-steps/${data.allLocalTours[0].id}/add-info`)
          } else {
            history.push('/activity-steps/add-info')
          }
        }
      )
    }).catch(err=>NotificationManager.error('Error while updatig needs to bring', 'Error', 5000))
  }

  render() {
    const { t, loading } = this.props
    const { saving, whatYouBring } = this.state

    if (loading) {
      return <Loader showLoader={true} />
    }

    return (
      <div className="steps-screen__form step-form faded-container">
        <div className="steps-screen__form-title">{t('need_to_bring')}</div>
        <Form
          onSubmit={this.handleSubmit}
          submitBtnClassname="btn btn-lg btn-primary btn-danger steps-submit-btn"
          submitBtnName={t('main:save_continue')}
          submittingToServer={saving}
        >
          <div className="steps-screen__form-input-area">
            <label className="steps-screen__form-input-label">{t('bring_description')}</label>
            <div className="form-input-example">{t('bring_spec')}</div>

            <TextAreaInput
              id="whatYouBring"
              placeholder={''}
              initialValue={whatYouBring}
              maxChars={200}
              validationFuncs={[validateRequired]}
              labelClass="steps-screen__form-input-label"
            />
          </div>
        </Form>
      </div>
    )
  }
}

const enhance = compose(
  translate('activity_steps'),
  graphql(UPDATE_LOCAL_TOUR, {
    name: 'updateLocalTour'
  }),
  withRouter
)

export default enhance(NeedToBring)



// WEBPACK FOOTER //
// src/components/ActivitySteps/Steps/MoreDetails/NeedToBring.jsx